<div>
    <h1>Import Assets </h1>
    <div class="flex-column main-container">
        <div style="flex: 1;">
            <p>This feature allows a list of Assets to be imported in bulk. Assets created with this method <br/>will not have Transaction data tied to them.</p>
            <p>Add your data to our template and upload the file to import Assets. Click the button below to <br/>download the Asset Import Template:</p>
            <div class="download-icon">
                <a href="./../../../../assets/AssetHub - Asset Import Template.xlsx" download>
                    <img src="./../../../../assets/images/ICO_Download-lg.png" alt="Donwload" matTooltip="Download Import Assets Template" />
                </a>
            </div>
            <ul>
                <li>The column headings in the template cannot be renamed, reordered, or altered in any way</li>
                <li>Additional columns cannot be added</li>
                <li>“Asset Name” and “Department Code (#)” are the only required fields for upload</li>
                <li>Other fields may be populated with data or remain blank</li>
            </ul>
        </div>
        <div class="flex justify-flex-end center flex-wrap" style="width: 600px;">
            <ah-assets-upload></ah-assets-upload>
        </div>
    </div>
</div>
